import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

try {
  createRoot(document.getElementById("root")!).render(<App />);
} catch {
  document.getElementById("nk-loader")?.remove();
  const root = document.getElementById("root");
  if (root) {
    root.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;min-height:100vh;text-align:center;padding:20px"><div><h3 style="color:#1E3A5F">Unable to load NightKept</h3><p style="color:#64748B">Please refresh the page.</p><button onclick="location.reload()" style="background:#E7A33B;color:white;border:none;padding:12px 24px;border-radius:8px;cursor:pointer;font-size:16px">Refresh</button></div></div>';
  }
}
